import { useTranslation } from 'react-i18next';
import { useCustomerAnalyticsGetAmountOfUsers } from '@app/domain/analytics/analytics.query.hooks';
import { QRLineChartBare } from './QRLineChartBare';
import { useCustomerAnalyticsGlobalFilterParams } from '@app/domain/analytics/analytics.url.hooks';
import { Container } from '@app/components';

export const QRAnalyticsTotalUsersChart: React.FC = () => {
  const { t } = useTranslation();
  const filters = useCustomerAnalyticsGlobalFilterParams();
  const { data, isLoading } = useCustomerAnalyticsGetAmountOfUsers(filters);

  return (
    <Container
      className="flex min-h-[340px] flex-col gap-4 lg:rounded-xl"
      isLoading={isLoading}
      title={t('qrAnalytics.amountOfUsers')}
    >
      {data && <QRLineChartBare data={data} />}
    </Container>
  );
};
